<template>
    <p v-if="haveCreditors != null && !haveCreditors" class="text-center">
        You Don’t Have Any <strong>Creditors Reporting</strong>. Please Import A <strong>Credit Report</strong>.
    </p>
    <div v-show="isInputFormActive && haveCreditors" class="row text-center mx-auto prev-item justify-content-center">
        <pagination :data="creditors" @pagination-change-page="getCreditors" />
    </div>
    <!-- Card Advance -->
    <div v-show="isInputFormActive && haveCreditors" class="row match-height">
        <!-- Developer Meetup Card -->
        <template v-for="creditor in creditors.data">
            <div class="col-lg-3 col-md-3 col-12">
                <div class="card card-developer-meetup">
                    <div class="card-body">
                        <div class="meetup-header d-flex align-items-center">
                            <div class="my-auto">
                                <h4 class="card-title mb-25">{{ creditor.creditor_name }}</h4>
                            </div>
                        </div>
                        <div class="media">
                            <div class="avatar bg-light-primary rounded mr-1">
                                <div class="avatar-content">
                                    <i data-feather="phone" class="avatar-icon font-medium-3"></i>
                                </div>
                            </div>
                            <div class="media-body">
                                <h6 class="mb-0">Phone</h6>
                                <small>{{ creditor.phone }}</small>
                            </div>
                        </div>
                        <div class="media">
                            <div class="avatar bg-light-primary rounded mr-1">
                                <div class="avatar-content">
                                    <i data-feather="map-pin" class="avatar-icon font-medium-3"></i>
                                </div>
                            </div>
                            <div class="media-body">
                                <h6 class="mb-0">Address</h6>
                                <small>{{ creditor.address }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <a href="#" @click="selectedCreditor(creditor)" type="button" class="btn btn-primary btn-block">Create</a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                            <div class="mb-2">
                                <label for="common-remedies">Common Remedies</label>
                                <Select2
                                    v-model="selectedRemedy"
                                    :options="remedies"
                                    :settings="{ multiple: true }"
                                    @change="myChangeEvent($event)"
                                    @select="mySelectEvent($event)"
                                />
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <h4>APPEND CLIENT DOCUMENTS</h4>
                                    <div class="display-box mb-1">
                                        <div class="ml-2">
                                            <input
                                                class="custom-control-input"
                                                type="checkbox"
                                                name="append_affidavit"
                                                value="1"
                                                tabindex="4"
                                                v-model="checkbox"
                                                id="append_affidavit"

                                            />
                                            <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                                ID Theft Affidavit
                                            </label>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <form >
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="creditorSelected.id" hidden>
                                <div class="col-md-12">
                                    <div id="editor">
                                        <editor
                                            id="debt_validation_letter"
                                            v-model="debt_validation_letter"
                                            :api-key="settingStore.tinymce.api_key"
                                            :init="settingStore.tinymce.configuration"
                                        />
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="button" name="editorType" value="1" @click.once="createLetter()">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                        <button
                                            id="letter-rewrite"
                                            class="btn btn-outline-primary ml-1"
                                            @click="spin"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <b-popover
                                                target="letter-rewrite"
                                                placement="top"
                                                triggers="hover"
                                                :html="true"
                                            >
                                                <template #title>
                                                    {{ localizationStore.translate("chat.pricing.title") }}
                                                </template>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                            {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('letter_rewrite') }) }}
                                                        </p>
                                                        <p v-else>
                                                            {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </b-popover>
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#chat-modal"
                                            class="btn btn-outline-primary mx-1"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("chat.button.title") }}
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#top-up-modal"
                                            class="btn btn-outline-primary"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.purchase.button.text") }}
                                        </button>
                                    </div>

                                <div class="row">
                                    <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRefSingle' />
                                </div>
                                </div>
                            </form>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <div style="padding: 10px 50px">
                <p>
                    DATE: {{ date }}
                    <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                    <br />
                    {{ userInfo.address }}
                    <br />
                    {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                    <br />
                    <br />
                    {{ creditorSelected.creditor_name }}
                    <br />
                    {{ creditorSelected.address }}
                    <br />
                    <br />
                    <br />
                    <strong> RE:DEBT VALIDATION LETTER</strong>
                    <br />
                    <br />
                    <strong>ATTN: LEGAL DEPARTMENT</strong>
                </p>
            </div>
            <div style="page-break-after: always; padding: 15px 50px;">
                <p class="letter-content">
                    Be advised this is a notice sent pursuant to the Fair Debt Collection Practices Act, 15 USC 1692g stating your claim is disputed and validation is requested.
                </p>
                <p class="letter-content">
                    This is NOT a request for “verification” or proof of my mailing address, but a request for VALIDATION made pursuant to the above-named Title and Section. I respectfully request your offices provide me with competent evidence that I have any legal obligation to pay you.
                </p>
                <p class="letter-content">
                    At this time, I will also inform you that if your offices have reported invalidated information to any of the 3 major credit bureaus (Equifax, Experian or TransUnion) this action may constitute fraud under both Federal and State Laws. Due to this fact, if any negative mark is found on any of my credit reports by your company or the company that you represent, I will not hesitate in bringing legal action against you and your client for the following: Violation of the Fair Credit Reporting Act, Violation of the Fair Debt Collection Practices Act, and Defamation of Character.
                </p>
                <p class="letter-content">
                    If your offices are able to provide the proper documentation as requested in the following Declaration, I will require at least 30 days to investigate this information, during which time all collection activity must cease and desist. Also, during this validation period, if any action is taken which could be considered detrimental to any of my credit reports, I will consult with my legal counsel for suit. This includes any listing of any information to a credit reporting repository that could be inaccurate or invalidated.
                </p>
                <p>
                    <strong class="letter-content">
                        If your office fails to respond to this validation request within 30 days from the date of your receipt, all references to this account must be deleted and completely removed from my credit file, and a copy of such deletion request shall be sent to me immediately.
                    </strong>
                </p>
                <br />
                <br />
                <br />
                <p>
                    Signature
                </p>
            </div>
            <div style="page-break-after: always; padding: 15px 50px;">
                <h1>
                    <strong>CEASE AND DESIST</strong>
                </h1>
                <p class="letter-content">
                    Pursuant to 15 USC 1692c.(c) I am notifying you in writing that I refuse to pay this alleged debt, and I am demanding that you cease all forms of communication with me through any and all mediums.
                </p>
                <p class="letter-content">
                    Pursuant to 15 USC 1692c.(c)(2)-
                    <br />
                    I am invoking my specified remedy as a consumer, and the original creditor I am demanding all of the following:
                </p>
                <ul>
                    <li v-for="remedy in selectedRemedy">{{ remedy }}</li>
                </ul>
                <p>
                    Best Regards,
                    <br />
                    <br />
                    Signature
                </p>
            </div>
            <div style="page-break-after: always; padding: 15px 50px;">
                <h1 style="text-align: center;">
                    <strong>QUESTIONS</strong>
                </h1>
                <ol>
                    <li>
                        Name and address of alleged creditor.
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Name on file of alleged debtor.
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Alleged account #
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Address on file for alleged debtor.
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Amount of alleged debt.
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Date this alleged debt became payable.
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Date of original charge or delinquency.
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Was this debt assigned to a debt collector or purchased?
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Amount paid if debt was purchased.
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                    <li>
                        Commission for debt if collection efforts are successful.
                        <br />
                        <br />
                        <u>__________________________________________________</u>
                        <br />
                        <br />
                    </li>
                </ol>
            </div>
            <div style="page-break-after: always; padding: 15px 50px;">
                <p class="letter-content">
                    Please attach copies of the following:
                    <br />
                    <ul>
                        <li>
                            Agreement with your client that grants {{ creditorSelected.creditor_name }} the authority to collect this alleged debt
                            <br>
                        </li>
                        <li>
                            Signed agreement Debtor has made with Debt Collector, or other verifiable proof Debtor has a contractual obligation to pay Debt Collector.
                            <br>
                        </li>
                        <li>
                            Any agreement that bears the signature of Debtor, wherein agreed to pay Creditor.
                            <br>
                        </li>
                        <li>
                            All statements while this account was open.
                            <br>
                        </li>
                        <li>
                            Have any insurance claims been made by any creditor regarding this account?
                            <br />
                            <input class="form-check-input" type="checkbox" id="yes" value="unchecked" />
                            <label class="form-check-label" for="yes">Yes</label>
                            <input class="form-check-input" type="checkbox" id="no" value="unchecked" />
                            <label class="form-check-label" for="no">No</label>
                            <br>
                        </li>
                        <li> Have any judgements been obtained by any creditor regarding this account?
                            <br />
                            <input class="form-check-input" type="checkbox" id="yes" value="unchecked" />
                            <label class="form-check-label" for="yes">Yes</label>
                            <input class="form-check-input" type="checkbox" id="no" value="unchecked" />
                            <label class="form-check-label" for="no">No</label>
                            <br>
                        </li>
                    </ul>
                </p>
                <p class="letter-content">
                    Please provide the name and address of the bonding agent for {{ creditorSelected.creditor_name }}, in case legal action becomes necessary:
                    <br />
                    <br />
                </p>
                <p> Authorized Signature of Creditor: </p>
                <p>__________________________________</p>
                <p> Date: </p>
                <p>_____________</p>
                <p class="letter-content">
                    You must return this completed form along with copies of ALL requested information, assignments or other transfer agreements, which would establish your right to collect this alleged debt within 30 days from the date of your receipt of this letter.
                    <br />
                    <br />
                    Your claim cannot and WILL NOT be considered if any portion of this form is not completed and returned with copies of all requested documents. This is a request for validation made pursuant to the Fair Debt Collection Practices Act.
                    <br />
                    <br />
                    Please allow 30 days for processing after I receive this information.
                </p>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import LaravelVuePagination from 'laravel-vue-pagination';
  import Select2 from 'vue3-select2-component';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  import { useLetterStore } from '../../stores/LetterStore.js'
  import { usePlanStore } from '../../stores/PlanStore.js'
  import { useSettingStore } from '../../stores/SettingStore.js'
  import Editor from '@tinymce/tinymce-vue'
  import { BPopover } from 'bootstrap-vue-3'
  export default {
    props: {
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
    },
    components: {
        'pagination': LaravelVuePagination,
        Select2,
        Editor
    },
    setup(props) {
        return {
            creditBureaus: props.propCreditBureaus,
            editorRefSingle: ref(null),
            date: ref(null),
            isInputFormActive: ref(true),
            haveCreditors: ref(null),
            localizationStore: useLocalizationStore(),
            userStore: useUserStore(),
            letterStore: useLetterStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            debt_validation_letter:ref(null),
            routes:ref([]),
            userInfo:reactive({}),
            checkbox:ref(false),
        };
    },
    created() {
    },
    data() {
        const creditorSelected = reactive([]);
        return {
            // Our data object that holds the Laravel paginator data
            creditors: {},
            selectedRemedy: '',
            creditorSelected,
            remedies: [
                'Pay the attached invoice and compensate me.',
                'Deletion from all consumer reports.',
                'Clear out payment history.',
                'Grant me my title lien free.',
                'Change all payment history to paid as agreed or on-time.',
                'Zero out on my open ended consumer plan balance monthly.',
                'Do not close my account(s) without authorized permission.',
                'Do not seize or attempt to seize anything in my possession.',
                'Remove all remarks or comments off my consumer report.',
                'Pay the attached bill of particulars for every violation labeled in the attached exhibits.',
                'Zero out the balance on this account.',
                'Return requested documents so I can properly assess the validity of any debt.',
                'Cease and rescind use of my intellectual property, my signature.'
            ]
        }
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                this.date = value.tdate
                this.userInfo = value
            }
        },
    },
    mounted() {
        let $this = this;
        if(!_.isEmpty($this.userStore.user)){
            $this.date = $this.userStore.tdate
            $this.userInfo = $this.userStore.user
        }else{
            $this.userStore.fetchUser();
        }
        this.getCreditors();
    },
    computed: {
    },
    methods: {
        getCreditors(page = 1) {
            let $this = this;
            let params = {
                type: 1,
                letter: this.letterStore.getId($this.$route.params.letter)
            };
            if ($this.$route.params.client) {
                params.client = $this.$route.params.client
            }
            if ($this.$route.params.team) {
                params.team = $this.$route.params.team
            }
            const listCreditBureau = $this.$router.resolve({
                name: 'disputes-creditBureau',
                params: params
            });
            axios.get(listCreditBureau.href + '?page=' + page)
                .then(response => {
                    this.creditors = response.data;
                    if (this.creditors.data.length > 0) {
                        this.haveCreditors = true;
                    }
                    else {
                        this.haveCreditors = false;
                    }
                });
        },
        createLetter(){
            let $this = this;
            let params = { letter: this.$route.params.letter };
            if (this.$route.params.client) {
                params.client = this.$route.params.client
            }
            if (this.$route.params.team) {
                params.team = this.$route.params.team
            }
            const createLetterRoute = this.$router.resolve({
                name: 'create-letter',
                params: params
            });
            let payload = {
                'letter_id' : this.letterStore.getId(this.$route.params.letter),
                'creditbureau' : this.creditorSelected.id,
                'editor' : this.debt_validation_letter,
                'editorType':1,
                append_affidavit : $this.checkbox,
            }
            axios.post(createLetterRoute.href, payload)
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    if($this.userStore.user.isDIY){
                        $this.$router.push({ name: 'disputes-report' });
                        return;
                    }
                    window.location.href = response.data.data.url;
                }, 3000)
            })
            .catch(function (error) {
                console.log(error);
            });


        },
        selectedCreditor(creditor) {
            this.creditorSelected = creditor;
            setTimeout(() => {
                this.debt_validation_letter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                // tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
                this.isInputFormActive = !this.isInputFormActive;
            }, "100");
        },
        goBack: function () {
            this.isInputFormActive = !this.isInputFormActive;
        },
        myChangeEvent(val){
            setTimeout(() => {
                this.debt_validation_letter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                // tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            }, "100");
            // tinymce.activeEditor.setContent(this.editorRefSingle.innerHTML);
            console.log(val);
        },
        mySelectEvent({id, text}){
            setTimeout(() => {
                this.debt_validation_letter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                // tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            }, "100");
            // tinymce.activeEditor.setContent(this.editorRefSingle.innerHTML);
            console.log({id, text})
        },
        spin() {
            this.$refs.spinner.spin(tinymce.get('debt_validation_letter'))
        },
        changeCheckbox(){
            this.checkbox = !this.checkbox
        }
    }
  };
</script>
<style scoped>
.card-developer-meetup {
    background: #f3f2f7;
}
</style>
